@for (banner of banners; track banner) {
  <div class="td-wb-global-notification-banner__wrapper">
    <ng-container *ngComponentOutlet="
                  banner.component;
                  inputs: banner.inputs;" />
  </div>
}
